import { ref } from 'vue';

export function useEditingMode() {
  const isEditingAnyResult = ref<boolean>(false);

  function enableEditing() {
    isEditingAnyResult.value = true;
  }

  function disableEditing() {
    isEditingAnyResult.value = false;
  }

  return { isEditingAnyResult, enableEditing, disableEditing };
}
